import React, { useState } from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Collapse from '@material-ui/core/Collapse';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';
import TuneIcon from '@material-ui/icons/Tune';
//import { Theme } from '@material-ui/core/styles/createTheme';
//import useMediaQuery from '@material-ui/core/useMediaQuery';

interface CollapseChartWrapperProps {
  initiallyExpanded?: boolean;
  children: React.ReactNode;
  svgPosX?: number;
}

const CollapseChartWrapper: React.FC<CollapseChartWrapperProps> = ({
  initiallyExpanded = false,
  children,
  svgPosX,
}) => {
  const [expanded, setExpanded] = useState(initiallyExpanded);

  const handleToggle = () => {
    setExpanded(!expanded);
  };

  //const isTablet = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'), { noSsr: true });

  return (
    <Box style={{ paddingLeft: `${svgPosX}px`, position: 'relative' }}>
      {!initiallyExpanded && (
        <Box mb={2}>
          <Button
            variant="text"
            startIcon={<TuneIcon />}
            endIcon={<ExpandMoreIcon style={{ transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)' }} />}
            onClick={handleToggle}
            style={{
              textTransform: 'none',
              justifyContent: 'space-between',
              //position: isTablet ? 'static' : 'absolute',
              //top: isTablet ? 'auto' : '-32px',
            }}
          >
            <Typography variant="h6">Možnosti grafu</Typography>
          </Button>
        </Box>
      )}
      <Collapse in={expanded}>{children}</Collapse>
    </Box>
  );
};

export default CollapseChartWrapper;
